<template>
  <div class="container">
    <div class="list">
      <div class="item">
        <div class="label">醫生姓名：</div>
        <input v-model="post.real_name" placeholder="請輸入醫生姓名" />
      </div>
      <div class="item">
        <div class="label">手機號碼：</div>
        <input v-model="post.phone" placeholder="請輸入醫生聯繫電話" />
      </div>
      <div class="item">
        <div class="label">所屬醫院：</div>
        <input v-model="post.hospital" placeholder="請輸入醫生所屬醫院" />
      </div>
      <div class="item">
        <div class="label">扣率：</div>
        <input v-model="post.brokerage" placeholder="請輸入扣率" />
      </div>
      <div class="add" @click="submit()">添加</div>
    </div>
  </div>
</template>

<script>
import { addDoctor } from "@api/user";
export default {
  name: "addDoctor",
  components: {},
  data() {
    return {
      post: {
        real_name: "",
        brokerage: "",
        hospital: "",
        phone: ""
      }
    };
  },
  computed: {},
  created() {},
  methods: {
    submit: function() {
      let that = this;
      let post = that.post;
      if (post.real_name == "") return this.$Message.error("請輸入名字");
      if (post.phone == "") return this.$Message.error("請輸入手機號碼");
      if (post.phone.length !== 11)
        return this.$Message.error("請輸入正確的手機號碼");
      if (post.hospital == "") return this.$Message.error("請輸入醫生所属医院");
      if (post.brokerage == "") return this.$Message.error("請輸入扣率");
      addDoctor(post).then(res => {
        console.log(res);
        this.$Message.success(res.msg);
        this.$router.push({
          path: `/home`
        });
        //that.$router.push("/user/promoter_list");
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
.list
  .item
      display flex
      align-items center
    .label
      font-size :20px
      margin-right :10px
      width 100px
      text-align :right
    input
      border 1px black solid
      padding: 4px 6px
      border-radius: 8px
    .add{
      font-size 16
      color #fff
      background-color red
      line-height 24px
      border-radius 10px
      padding 1px 4px
      width 50px
      box-sizing border-box
      text-align center
      cursor pointer
      margin-left 100px
      margin-top 10px
    }
</style>
